import { useIntl } from "react-intl";

import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { PaidHeroTabPanelTemplate } from "./hero-tab-panel-template";

const AllTeamsTabContent = () => {
    const intl = useIntl();

    const gwp9473JSWAnchorUpdates = checkFeatureFlagGate(
        featureFlags.gwp9473JSWAnchorUpdates
    );

    const allTeamsHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.header",
            defaultMessage:
                "Connect every team, task, and project together with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/t501oo65h16scx35qe60q32dj6a4782t.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.default.heroImageAlt",
                defaultMessage: "Screen capture of a Jira backlog"
            })
        },
        showAnimatedHero: true
    };

    const gwp9473JSWAnchorUpdatesHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.hero.header",
            defaultMessage: "Where your teams and AI come together"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/wdmncs35471g5521yr5462w3ku0t834b.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.default.heroImageAlt",
                defaultMessage: "Screen capture of a Jira list view"
            })
        },
        showAnimatedHero: false
    };

    return (
        <PaidHeroTabPanelTemplate
            {...(gwp9473JSWAnchorUpdates
                ? gwp9473JSWAnchorUpdatesHeroProps
                : allTeamsHeroProps)}
            isAllTeamsTab={true}
        />
    );
};

export default AllTeamsTabContent;
